import React from "react";
import { useContent } from "../context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const f = content.footer || {};
  return (
    <footer className="footer mt-auto">
      <div className="container text-center">
        <h5 className="fw-bold">{f.title || "Himmelstor Farm"}</h5>
        <p>{f.tagline || ""}</p>
        <p className="mb-1">Phone: {f.phone} | Email: {f.email}</p>
        <p className="mb-0">&copy; {new Date().getFullYear()} {f.title || "Himmelstor Farm"}. All rights reserved.<br />{f.companyReg || ""}</p>
        <div className="mt-4 pt-3 border-top" style={{ borderColor: "rgba(255,255,255,0.12)" }}>
        <p className="small text-muted mb-0" style={{ letterSpacing: "0.08em", textTransform: "uppercase", fontSize: "0.65rem" }}>
          Designed & Engineered by{" "}
          <a href="http://cybercothtechnetworks.co.zw/" target="_blank" rel="noopener noreferrer" className="footer-credit-link">
            Cyber Comptech Networks
          </a>
        </p>
        </div>
      </div>
    </footer>
  );
}
